import { useContext } from 'react';
import { getIsReportValidForCustomizationComponentId } from 'report-customization-components/lib/reportCustomizationComponentFetchers';
// @ts-expect-error Untyped dependency
import { isEditableReport } from 'reporting-action-components/lib/report-logic';
import { isConfigReport, isRelationalReport, isUnifiedEventsQLReport } from 'reporting-data/tsTypes/reportTypes';
import { UserInfoContext } from 'reporting-data/userInfo/userInfoContext';
import { getIsUngatedForSRVLiteEditting, getIsUngatedToSRVLiteEditingSnowflake } from '../../../../constants/gates';
import { useEditors } from '../../../reportEditors/common/useEditorsAndFilters';
import { REPORT_OPTIONS_LITE_EDITING_CONTROLS } from '../../fullPage/sidebar/utils';
import { isReportValidForDataColumnsModal } from 'report-customization-components/components/data-columns-modal/utils';
import { isAllowableChartTypeForRelationalEditing } from 'report-customization-components/lib/shared-utils';
const useGetIsReportValidForLiteEdittingPanel = (report, condensedFullpageView = false) => {
  const userInfo = useContext(UserInfoContext);
  const editors = useEditors(report);
  const isUngatedForSRVLiteEditting = getIsUngatedForSRVLiteEditting(userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates);
  const isUngatedToSRVLiteEditingSnowflake = getIsUngatedToSRVLiteEditingSnowflake(userInfo.gates);
  const numberOfValidReportControls = [...REPORT_OPTIONS_LITE_EDITING_CONTROLS].filter(controlId => {
    return getIsReportValidForCustomizationComponentId(controlId, report, userInfo);
  });
  const isLiteEditingEnabled = isUngatedForSRVLiteEditting || condensedFullpageView;
  const hasReportEditors = (editors === null || editors === void 0 ? void 0 : editors.length) > 0;
  const hasValidReportControls = (numberOfValidReportControls === null || numberOfValidReportControls === void 0 ? void 0 : numberOfValidReportControls.length) > 0;
  const isDataColumnsModalValid = isReportValidForDataColumnsModal(report, userInfo);
  const isReportEditable = isEditableReport(report);
  const reportEditableAndValid = isReportEditable && (hasValidReportControls || isDataColumnsModalValid);
  if (isRelationalReport(report)) {
    return isUngatedToSRVLiteEditingSnowflake && isLiteEditingEnabled && !!(reportEditableAndValid || hasReportEditors) && isAllowableChartTypeForRelationalEditing(report);
  }
  if (isUnifiedEventsQLReport(report)) {
    return isLiteEditingEnabled;
  }
  if (isConfigReport(report)) {
    return isLiteEditingEnabled && !!(reportEditableAndValid || hasReportEditors);
  }
  return false;
};
export default useGetIsReportValidForLiteEdittingPanel;